import React from 'react';

import _ from 'lodash';

import ViewConstants from 'constants/ViewConstants';

import {
  withGoogleMap,
  GoogleMap,
  InfoWindow,
  Circle,
  Marker
} from "react-google-maps";

const GoogleMapView = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={props.zoom}
    defaultCenter={props.defaultCenter}
    onLoad={props.onMapLoad}
    onClick={props.onMapClick}
  >
    {props.location && (
        // see https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
          <Marker
            key={'restaurant_marker'}
            position={props.location}
            icon={
              {
                // url: `http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=${index + 1}|FE6256|000000`,
                url: ViewConstants.Image.USER_MAP_CURSOR,
                origin: new props.google.maps.Point(0, 0),
                // define size here
                scaledSize: new props.google.maps.Size(20, 20)
              }
            }
            options={{
            }}
            defaultAnimation={2}
          />
    )}

    {/* // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle */}
    <Circle
      center={props.location}
      radius={props.userCircleRadius}
      onClick={_.noop}
      options={{
        // editable: true,
        onRadiusChanged: props.onRadiusChange,
        onCenterChanged: _.noop,
        fillColor: `red`,
        fillOpacity: 0.20,
        strokeColor: `red`,
        strokeOpacity: 1,
        strokeWeight: 1,
      }}
    />
  </GoogleMap>
  )
);

export default GoogleMapView;



// WEBPACK FOOTER //
// ./scripts/pages/order/settings/modes/components/maps/GoogleMapView.js